import { Icon, RawBrandCode, RawImageData, RawParagraphData } from '@activebrands/core-web/libs/storyblok/storyblok';
import extractBackgroundOverlays, {
    BackgroundOverlaysTypes,
} from '@activebrands/core-web/libs/storyblok/utils/extract-background-overlays';
import { TransformedBackgroundTypes } from '@activebrands/core-web/libs/storyblok/utils/transform-flexible-background';
import transformFlexibleBackgrounds from '@activebrands/core-web/libs/storyblok/utils/transform-flexible-backgrounds';
import transformParagraph, { ParagraphType } from '@activebrands/core-web/libs/storyblok/utils/transform-paragraph';

export interface RawBrandBlock {
    component: 'brandBlock';
    brandCode: RawBrandCode;
    description: Array<RawParagraphData>;
    image: Array<RawImageData>;
    logo: Array<Icon>;
}

type Logo = {
    icon: {
        filename: string;
    };
};

export interface BrandBlock {
    brand: string;
    brandCode: number;
    image?: Array<TransformedBackgroundTypes>;
    logo?: Logo;
    overlay?: BackgroundOverlaysTypes;
    text?: ParagraphType;
}

export const transformBrandBlock = (item: RawBrandBlock): BrandBlock => {
    const { brandCode, description, image, logo } = item;
    const backgroundOverlay = image.length > 0 ? extractBackgroundOverlays([image[0]]) : undefined;
    const transformedImage =
        image.length > 0 ? transformFlexibleBackgrounds([image[0]], [1, null, 0.5, null, 0.25]) : undefined;

    return {
        image: transformedImage,
        overlay: backgroundOverlay,
        brand: brandCode.data?.brand,
        brandCode: brandCode.data?.brandCode,
        logo: logo?.[0]?.icon?.[0],
        text: transformParagraph({ paragraph: description }),
    };
};

export const transformBrandBlocks = (items: RawBrandBlock[]): BrandBlock[] => {
    return items.map(transformBrandBlock);
};
